import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal, Button, Select, Radio, Tag, Grid } from 'antd';
import { Flex, Input, Space, notification, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
	XThemeModal,
	XThemeForm,
	XThemeSwitchBtn,
	XThemeTag2,
	XEditButtonIcon,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeModalScroll,
	XThemeButton,
	XThemeFilterCircleButton,
} from '../../styles/GlobalThemeStyle';
import {
	EditOutlined,
	DeleteOutlined,
	PlusCircleFilled,
	PlusOutlined,
} from '@ant-design/icons';
import moment from 'moment';
// Actions
import {
	getDefaultRolesApi,
	getDefaultRolesReset,
} from '../../actions/getDefaultRolesAction';
import { getModulesApi, getModulesReset } from '../../actions/getModulesAction';
import {
	getRoleByIdApi,
	getRoleByIdReset,
} from '../../actions/getRoleByIdAction';
import { createRoleApi, createRoleReset } from '../../actions/createRoleAction';
import { editRoleApi, editRoleReset } from '../../actions/editRoleAction';
import { deleteRoleApi, deleteRoleReset } from '../../actions/deleteRoleAction';
// utils
import { handleInputChange } from '../../utils/formFunctions';
import DataTable from '../../components/DataTable/DataTable';
import { checkModulePermissions, urlPagination } from '../../utils/helper';
import { getOrganizationsApi } from '../../actions/getOrganizationsAction';
import { dateFilters } from '../../utils/constants';
import { XTheme2InnerCard } from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
} from '../../styles/GlobalThemeStyleCQ';

const DefaultRoleManagement = (props) => {
	const {
		getDefaultRoles,
		getDefaultRolesReset,
		getDefaultRolesState,
		getModules,
		getModulesReset,
		getModulesState,
		getRoleById,
		getRoleByIdReset,
		getRoleByIdState,
		createRole,
		createRoleReset,
		createRoleState,
		deleteRole,
		deleteRoleReset,
		deleteRoleState,
		editRole,
		editRoleReset,
		editRoleState,
		getOrganizations,
		getOrganizationsState,
	} = props;

	const defaultFilters = {
		search: '',
		page: 1,
		role: '',
		created_on: '',
		limit: 10,
	};
	const [form] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [modalOpen, setModalOpen] = useState([false, '']);
	const [tableData, setTableData] = useState([]);
	const [moduleList, setModuleList] = useState([]);
	const [editRoleActive, setEditRoleActive] = useState(false);
	const [totalRecords, setTotalRecords] = useState('');
	const [currentPermissions, setCurrentPermissions] = useState([]);
	const [displayOrganization, setDisplayOrganization] = useState(false);

	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('role-management').sub_modules.includes(
			'list-roles',
		) && getDefaultRoles({ type: 'super-admin', ...updatedFilters });
	}, [window.location.search]);

	useEffect(() => {
		if (getDefaultRolesState.apiState === 'success') {
			if (getDefaultRolesState.data.all_roles.length > 0) {
				const updatedTableData = [];
				setTotalRecords(getDefaultRolesState.data.total_count);
				getDefaultRolesState.data.all_roles.map((item, index) => {
					updatedTableData.push({
						key: item._id,
						_id: item._id,
						role: item.display_name,
						modules:
							item.permissions.map((mod) => (
								<XThemeTag2>
									{mod.module.module_name}
								</XThemeTag2>
							)) || '-',
						display_name: item.display_name,
						createdOn: (
							<div className="showDate">
								{moment(item.createdAt).format('DD-MM-YYYY')}
							</div>
						),
						action: (
							<div className="text-center">
								{checkModulePermissions(
									'role-management',
								).sub_modules.includes('update-roles') ? (
									<XEditButtonIcon
										onClick={() => {
											handleEdit(item);
										}}
										type="text"
									>
										<img src="./images/pencil.svg" alt="" />
									</XEditButtonIcon>
								) : (
									<></>
								)}
							</div>
						),
					});
				});
				setTableData(updatedTableData);
				getDefaultRolesReset();
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getDefaultRolesState]);

	useEffect(() => {
		if (getModulesState.apiState === 'success') {
			if (getModulesState.data.length > 0) {
				let module_list = [];

				getModulesState.data.map((item) => {
					let sub_modules = [];

					item.sub_modules.map((itm) => {
						let sub_mod = {
							id: itm._id,
							name: itm.sub_module_name,
							included: false,
						};

						if (editRole) {
							let subModuleCheck = currentPermissions?.filter(
								(mod) => {
									if (item._id === mod.module[0]._id) {
										if (
											mod.sub_modules?.includes(itm._id)
										) {
											return mod;
										}
									}
								},
							);
							if (subModuleCheck.length > 0) {
								sub_mod.included = true;
							}
						}
						sub_modules.push(sub_mod);
					});

					module_list.push({
						id: item._id,
						name: item.module_name,
						sub_modules,
					});
				});

				setModuleList(module_list);
			}
			// else {
			// 	notification.error({
			// 		message: 'No Modules defined for Super admin',
			// 	});
			// }
			getModulesReset();
		}
	}, [getModulesState]);

	useEffect(() => {
		if (createRoleState.apiState === 'success') {
			form.resetFields();
			setFormData({});
			createRoleReset();
			setModuleList([]);
			getDefaultRoles({ type: 'super-admin' });
			setCurrentPermissions([]);
			notification.success({
				message: createRoleState.message,
			});
			setModalOpen([false, '']);
		}
		if (createRoleState.apiState === 'error') {
			notification.error({
				message: createRoleState.message,
			});
			createRoleReset();
		}
	}, [createRoleState]);

	useEffect(() => {
		if (editRoleState.apiState === 'success') {
			form.resetFields();
			setFormData({});
			editRoleReset();
			setModuleList([]);
			getDefaultRoles({ type: 'super-admin' });
			setCurrentPermissions([]);
			notification.success({
				message: editRoleState.message,
			});
			setModalOpen([false, '']);
			setEditRoleActive(false);
		}
		if (editRoleState.apiState === 'error') {
			notification.error({
				message: editRoleState.message,
			});
			editRoleReset();
			setEditRoleActive(false);
		}
	}, [editRoleState]);

	useEffect(() => {
		if (deleteRoleState.apiState === 'success') {
			notification.success({
				message: deleteRoleState.message,
			});
			deleteRoleReset();
			setEditRoleActive(false);
			getDefaultRoles({ type: 'super-admin' });
		}
	}, [deleteRoleState]);

	useEffect(() => {
		if (getRoleByIdState.apiState === 'success') {
			setCurrentPermissions(getRoleByIdState.data.permissions);
			setFormData({
				id: getRoleByIdState.data._id,
				role_name: getRoleByIdState.data.display_name,
			});
			form.setFieldsValue({
				id: getRoleByIdState.data._id,
				role_name: getRoleByIdState.data.display_name,
			});
			getRoleByIdReset();
		}
	}, [getRoleByIdState]);

	// Functions
	const showDeleteConfirm = (_id) => {
		setModalOpen(false);
		XThemeModal.confirm({
			title: 'Delete Role?',
			content: (
				<p className="modalPara1">
					Are you sure you want to delete this role?
				</p>
			),
			icon: <img className="me-3" src="/images/delete-icon.svg" alt="" />,
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelText: 'No, Cancel',
			className: 'confirmModal',
			onOk() {
				deleteRole({ id: _id });
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	const subModuleSelected = (checked, moduleKey, subModuleKey) => {
		const updatedModuleList = [...moduleList];
		updatedModuleList[moduleKey] = {
			...updatedModuleList[moduleKey],
			sub_modules: [...updatedModuleList[moduleKey].sub_modules],
		};
		updatedModuleList[moduleKey].sub_modules[subModuleKey] = {
			...updatedModuleList[moduleKey].sub_modules[subModuleKey],
			included: checked,
		};
		setModuleList(updatedModuleList);
	};

	const moduleSelected = (value, moduleKey) => {
		const updatedModuleList = moduleList.map((module, index) => {
			if (index === moduleKey) {
				const updatedSubModules = module.sub_modules.map(
					(subModule) => {
						return { ...subModule, included: value };
					},
				);
				return { ...module, sub_modules: updatedSubModules };
			}
			return module;
		});

		setModuleList(updatedModuleList);
	};

	const isAnySubModuleUnchecked = (moduleKey) => {
		const selectedModule = moduleList[moduleKey];
		const uncheckedSubModule = selectedModule.sub_modules.find(
			(subModule) => !subModule.included,
		);
		return !!uncheckedSubModule;
	};

	const updateRoleDetails = (id) => {
		editRole({
			id: formData.id,
			role: formData.role_name,
			permissions: moduleList,
		});
	};

	const saveRole = () => {
		form.validateFields()
			.then(() => {
				const allIncludedFalse = moduleList.every((module) =>
					module.sub_modules.every(
						(subModule) => !subModule.included,
					),
				);
				if (allIncludedFalse) {
					form.setFields([
						{
							name: 'permissions',
							errors: [
								'Please give access to atleast one module',
							],
						},
					]);
					return;
				} else {
					createRole({
						role: formData.role_name,
						permissions: moduleList,
					});
				}
			})
			.catch((err) => {});
	};

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};
	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};

	const handleEdit = (item) => {
		setEditRoleActive(true);
		getRoleById({ id: item._id });
		getModules({
			type: 'super-admin',
		});
		setFormData({
			_id: item._id,
			role: item.display_name,
		});
		// setModalOpen([true, `Edit ${item.display_name}`]);
	};

	//Edit Modal display only after the state has changed so that the data get loaded completly
	useEffect(() => {
		if (editRoleActive) setModalOpen([true, `Edit ${formData.role}`]);
	}, [editRoleActive]);

	useEffect(() => {
		if (localStorage.getItem('role') === 'super-admin')
			setDisplayOrganization(true);
	}, []);

	const columns = [
		{
			title: 'Role',
			dataIndex: 'role',
			width: 200,
		},
		{
			title: 'Modules',
			dataIndex: 'modules',
			width: 700,
		},
		{
			title: 'Created on',
			dataIndex: 'createdOn',
		},
		{
			title: <div className="text-center">Action</div>,
			dataIndex: 'action',
			width: '10%',
		},
	];
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<XTheme2InnerCard
				className="mb-3"
				bodyStyle={{ padding: '20px 0px' }}
			>
				<div className="smallTopBottomPadding mb-3 px-4">
					<Row gutter={(15, 15)} className="align-items-center">
						<Col xs={12} sm={24} md={6} lg={4}>
							<h1
								className="cardTitle mb-0"
								style={{ fontSize: '18px' }}
							>
								Total {totalRecords} Roles
							</h1>
						</Col>
						<Col
							xs={24}
							sm={16}
							md={12}
							lg={12}
							className="d-none d-md-block"
						>
							<Space>
								<XTheme2InputText
									size="large"
									allowClear
									placeholder="Search By Role Name"
									defaultValue={
										filters.role_name
											? filters.role_name
											: null
									}
									onChange={(v) => {
										if (v.target.value === '') {
											urlPagination(
												filters,
												'role_name',
												'',
											);
											setFilters({
												...filters,
												role_name: '',
											});
										} else {
											setFilters({
												...filters,
												role_name: v.target.value,
											});
										}
									}}
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											const searchValue =
												filters.role_name
													? filters.role_name
													: '';
											if (searchValue) {
												urlPagination(
													filters,
													'role_name',
													searchValue,
												);
												setFilters({
													...filters,
													role_name: searchValue,
												});
											}
										}
									}}
								/>
								<XTheme2Button
									onClick={() => {
										// Trigger search when the button is clicked
										const searchValue = filters.role_name
											? filters.role_name
											: '';
										if (searchValue) {
											urlPagination(
												filters,
												'role_name',
												searchValue,
											);
											setFilters({
												...filters,
												role_name: searchValue,
											});
										}
									}}
									className="px-4"
									size="large"
								>
									Search
								</XTheme2Button>
							</Space>
							{/* <XThemeForm.Item>
						<XSearch
							placeholder="Search By Role Name"
							allowClear
							enterButton="Search"
							size="large"
							defaultValue={
								filters.role_name ? filters.role_name : null
							}
							onChange={(v) => {
								if (v.target.value === '') {
									urlPagination(filters, 'role_name', '');
									setFilters({
										...filters,
										role_name: '',
									});
								}
							}}
							onSearch={(v) => {
								urlPagination(filters, 'role_name', v);
								setFilters({
									...filters,
									role_name: v,
								});
							}}
						/>
					</XThemeForm.Item> */}
						</Col>

						<Col xs={12} sm={8} md={6} lg={8} className="text-end">
							<Space>
								{checkModulePermissions(
									'role-management',
								).sub_modules.includes('create-roles') ? (
									isMobile ? (
										<XTheme2Button
											className="noBackground"
											shape="circle"
											size="large"
											onClick={() => {
												getModules({
													type: 'super-admin',
												});
												setModalOpen([
													true,
													'Add Role',
												]);
											}}
											icon={<PlusOutlined />}
										/>
									) : (
										<XTheme2Button
											size="large"
											onClick={() => {
												getModules({
													type: 'super-admin',
												});
												setModalOpen([
													true,
													'Add Role',
												]);
											}}
											icon={<PlusOutlined />}
										>
											New Role
										</XTheme2Button>
									)
								) : (
									<></>
								)}
							</Space>
						</Col>
					</Row>
				</div>
				<DataTable
					columns={columns}
					tableData={tableData}
					state={getDefaultRolesState.apiState}
					totalRecords={totalRecords}
					setFilters={setFilters}
					filters={filters}
					page={'role-management'}
					handleEdit={handleEdit}
					showDeleteConfirm={showDeleteConfirm}
				/>
				<XThemeModal
					title={modalOpen[1]}
					centered
					open={modalOpen[0]}
					// onOk={() => {
					// 	editRoleActive ? updateRoleDetails() : saveRole();
					// }}
					onCancel={() => {
						form.resetFields();
						setFormData({});
						setCurrentPermissions([]);
						setModalOpen([false, '']);
						setEditRoleActive(false);
					}}
					cancelButtonProps={{ hidden: 'none' }}
					okButtonProps={{ hidden: 'none' }}
					className="modalButtonBoth mt-5 pt-5 mt-md-0 pt-md-0"
					okText="Submit"
					zIndex={1100}
					width={850}
				>
					<XThemeForm
						form={form}
						name="roleForm"
						layout="vertical"
						autoComplete="off"
					>
						<Row gutter={(15, 15)} className="mt-4">
							<Col xs={24} sm={24} lg={12}>
								<XThemeForm.Item
									className="drawerlabel"
									name="role_name"
									label="Enter Role Name"
									rules={[
										{
											required: true,
											message: 'Please enter role name',
										},
									]}
								>
									<XThemeInputText
										className="noBorderRadius"
										size="large"
										placeholder="Enter Role Name"
										name="role_name"
										onChange={(e) =>
											handleInputChange(
												e,
												formData,
												setFormData,
											)
										}
									/>
								</XThemeForm.Item>
							</Col>
						</Row>
						<Row gutter={(15, 15)}>
							<Col xs={24}>
								<XThemeForm.Item
									name="permissions"
									className="mb-0"
								>
									<h1 className="XThemeModalTitle">
										Give Access
									</h1>
								</XThemeForm.Item>
							</Col>
						</Row>
						<XThemeModalScroll>
							{moduleList.length > 0 &&
								moduleList.map((item, module_key) => (
									<>
										<div className="allCheckTitle">
											<Row
												gutter={(15, 15)}
												className="align-items-center"
											>
												<Col xs={20}>
													<span>{item.name}</span>
												</Col>
												<Col
													xs={4}
													className="text-end"
												>
													<div className="customHeader">
														<XThemeSwitchBtn
															defaultChecked
															size="small"
															onChange={(value) =>
																moduleSelected(
																	value,
																	module_key,
																)
															}
															checked={
																!isAnySubModuleUnchecked(
																	module_key,
																)
															}
														/>
													</div>
												</Col>
											</Row>
										</div>
										<Row gutter={(15, 15)} className="mt-3">
											<Col xs={24}>
												<Row gutter={(15, 15)}>
													{item.sub_modules.length >
														0 &&
														item.sub_modules.map(
															(
																itm,
																sub_module_key,
															) => (
																<>
																	<Col
																		xs={18}
																		md={4}
																		lg={4}
																		className="mb-3"
																	>
																		<span>
																			{
																				itm.name
																			}
																		</span>
																	</Col>
																	<Col
																		xs={6}
																		lg={3}
																		md={4}
																		className="mb-3"
																	>
																		<XThemeSwitchBtn
																			size="small"
																			checked={
																				itm.included ===
																				true
																			}
																			onChange={(
																				checked,
																			) =>
																				subModuleSelected(
																					checked,
																					module_key,
																					sub_module_key,
																				)
																			}
																		/>
																	</Col>
																</>
															),
														)}
												</Row>
											</Col>
										</Row>
									</>
								))}
						</XThemeModalScroll>
						<Row className="mt-3" gutter={[15, 15]}>
							<Col xs={24} className="text-end">
								<Space>
									{checkModulePermissions(
										'role-management',
									).sub_modules.includes('delete-roles') ? (
										<Button
											className="xThemeCancelSubmit"
											size="large"
											onClick={() =>
												showDeleteConfirm(formData.id)
											}
										>
											Delete
										</Button>
									) : (
										<></>
									)}

									{checkModulePermissions(
										'role-management',
									).sub_modules.includes('delete-roles') ? (
										<Button
											className="xThemeButtonSubmit"
											size="large"
											onClick={() =>
												editRoleActive
													? updateRoleDetails()
													: saveRole()
											}
										>
											Save
										</Button>
									) : (
										<></>
									)}
								</Space>
							</Col>
						</Row>
					</XThemeForm>
				</XThemeModal>
			</XTheme2InnerCard>
		</>
	);
};

const mapStateToProps = (state) => ({
	getDefaultRolesState: state.getDefaultRoles,
	getModulesState: state.getModules,
	getRoleByIdState: state.getRoleById,
	createRoleState: state.createRole,
	deleteRoleState: state.deleteRole,
	editRoleState: state.editRole,
	getOrganizationsState: state.getOrganizations,
});

const mapDispatchToProps = (dispatch) => ({
	getDefaultRoles: (params) => dispatch(getDefaultRolesApi(params)),
	getDefaultRolesReset: () => dispatch(getDefaultRolesReset()),
	getModules: (params) => dispatch(getModulesApi(params)),
	getModulesReset: () => dispatch(getModulesReset()),
	getRoleById: (params) => dispatch(getRoleByIdApi(params)),
	getRoleByIdReset: () => dispatch(getRoleByIdReset()),
	createRole: (params) => dispatch(createRoleApi(params)),
	createRoleReset: () => dispatch(createRoleReset()),
	deleteRole: (params) => dispatch(deleteRoleApi(params)),
	deleteRoleReset: () => dispatch(deleteRoleReset()),
	editRole: (params) => dispatch(editRoleApi(params)),
	editRoleReset: () => dispatch(editRoleReset()),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(DefaultRoleManagement);
